export default __webpack_public_path__ + "static/media/link-off.22082922.svg";